import { Component, Input, HostBinding } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'app-chip',
	standalone: true,
	imports: [MatIconModule],
	templateUrl: './chip.component.html',
	styleUrl: './chip.component.scss',
})
export class ChipComponent {
	@Input() labelInput!: string | undefined;
	@Input() disabled?: boolean = false;
	@Input() style?: any;
	@Input() color?: string = 'var(--goldstar-blue-rgb)';

	@HostBinding('style.--chip-main-color') get mainColor() {
		return this.color;
	}

	@Input() onDelete?: any;
	handleDelete(event: MouseEvent) {
		if (this.onDelete) {
			this.onDelete(event);
		}
	}
}
